import React from 'react'
// Ant Design
import { Breadcrumb, Flex } from 'antd'
// React Router
import { Link } from 'react-router-dom'

export const BreadCrumb = ({t}) => {
    return (
        <Flex style={{width: "50%"}}>
            <Breadcrumb 
                style={{fontSize: "18px"}}
                items={[
                    {
                        title: "Home",
                    },
                    {
                        title: <Link to="/list">{t("list_templates")}</Link>,
                    },
                    {
                        title: t("list_agent"),
                    },
                ]}
            />
        </Flex>
    )
}